import { useTranslation } from "react-i18next";
import { useDocumentsScreenSuspenseQuery } from "../client/generated";
import { Scaffold } from "../shell/Scaffold";
import { DocumentTable } from "../documents/DocumentTable";
import { Navbar } from "../shell/Navbar";
import { ScrollArea } from "@acdc2/ui/components/scroll-area";
import { Display } from "@acdc2/ui/components/access-typography";

export function DocumentsScreen() {
  const { t } = useTranslation();
  const { data } = useDocumentsScreenSuspenseQuery();

  return (
    <Scaffold navbar={<Navbar />}>
      <ScrollArea>
        <div className="p-8 gap-8 flex flex-col">
          <Display asChild>
            <h1 data-testid="documents-screen-heading">
              {t("DocumentsScreen.title")}
            </h1>
          </Display>
          <DocumentTable fragment={data.viewer.memberships} />
        </div>
      </ScrollArea>
    </Scaffold>
  );
}
